'use strict';

var _ = require('lodash');
var DropdownValuesSearchCriteriaMatcherService = function DropdownValuesSearchCriteriaMatcherService(currentStateCriteriaService) {
  /**
   * Map field name from search criteria to field in values array
   *
   * @type {{}}
   */
  var fieldsMap = {};
  var operatorsMap = {
    '=': 'equals',
    '!=': 'diff'
  };
  var searchCriteriaRules = currentStateCriteriaService.getSearchCriteria().rules;

  /**
   * Set fields map
   *
   * @param map
   */
  function setFieldsMap(map) {
    fieldsMap = map;
  }

  /**
   * Get current search criteria
   */
  function refreshSearchCriteria() {
    searchCriteriaRules = currentStateCriteriaService.getSearchCriteria().rules;
  }

  /**
   * Creates an object with rules for each field
   *
   * @returns {{}}
   */
  function prepareRules() {
    var rules = {};
    if (_.isEmpty(fieldsMap)) {
      throw new Error('Please provide fields map for DropdownValuesSearchCriteriaMatcherService');
    }
    _.forEach(searchCriteriaRules, function (rule) {
      if (_.keys(fieldsMap).indexOf(rule.criterion) !== -1) {
        rules[fieldsMap[rule.criterion]] = {
          operator: operatorsMap[rule.operator],
          operand: _.map(rule.leftOperand, _.toString)
        };
      }
    });
    return rules;
  }
  var matchingFunctions = {
    equals: function equals(operand, value) {
      return operand.indexOf(value) !== -1;
    },
    diff: function diff(operand, value) {
      return operand.indexOf(value) === -1;
    }
  };

  /**
   * Check if value is matching search criteria rules
   *
   * @param field
   * @param value
   * @returns {boolean}
   */
  function match(field, value) {
    var rules = prepareRules();
    if (_.has(rules, field)) {
      return matchingFunctions[rules[field].operator].call(null, rules[field].operand, value[field]);
    }
    return true;
  }
  return {
    setFieldsMap: setFieldsMap,
    refreshSearchCriteria: refreshSearchCriteria,
    match: match
  };
};
DropdownValuesSearchCriteriaMatcherService.$inject = ['CurrentStateCriteriaService'];
module.exports = DropdownValuesSearchCriteriaMatcherService;